import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import './FileUploader.css';

const FileUploader = ({ onFilesSelected, disabled }) => {
  const onDrop = useCallback(onFilesSelected, [onFilesSelected]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    disabled,
  });

  return (
    <div {...getRootProps()} className={`file-uploader ${isDragActive ? 'active' : ''} ${disabled ? 'disabled' : ''}`}>
      <input {...getInputProps()} />
      {
        isDragActive ?
          <p>Drop the files here ...</p> :
          <p>Drag and drop some files here, or click to select files</p>
      }
    </div>
  );
};

export default FileUploader;